import { useIntl } from 'react-intl';
import { InGameLayout } from '../layout/in-game-layout';
import { Menu } from '../components/menu';
import MainContent from '../layout/main-content';
import ProjectsPicker from '../components/projects-picker';
import Button from '../components/button';

const CostCentersPage = () => {
  const { formatMessage } = useIntl();
  return (
    <InGameLayout side={<Menu />}>
      <MainContent
        title={formatMessage({ id: 'costCenters.title' })}
        hideFrame
        extra={<ProjectsPicker className="relative -top-8" />}
        controls={<Button variant="solid">Edit Budgets</Button>}
      >
        <div className="" />
      </MainContent>
    </InGameLayout>
  );
};

export default CostCentersPage;
